// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.material {
  color: #666;
  font-weight: 400;
}

.request-header-metrics {
  margin-top: 10px;
  display: grid;
  gap: 8px;
  max-width: 640px;
  background-color: #f7f8fa;
  border: 1px solid #e9ecef;
  border-radius: 6px;
  padding: 10px 12px;
}

.metric-item {
  display: grid;
  grid-template-columns: 130px minmax(0, 1fr);
  align-items: center;
  column-gap: 10px;
}

.metric-label {
  font-size: 1rem;
  font-family: "GothamNarrowBold", Arial, sans-serif;
  color: #111;
  margin: 0;
}

.metric-value {
  font-size: 1rem;
  line-height: 1.3;
  color: #555;
  background-color: #ededee;
  border-radius: 4px;
  padding: 4px 10px;
  min-height: 30px;
  display: flex;
  align-items: center;
  gap: 4px;
  flex-wrap: wrap;
}

.metric-unit {
  white-space: nowrap;
}

.metric-delta {
  font-weight: 600;
  color: #555;
}
.metric-delta.positive {
  color: #1b5e20;
}
.metric-delta.negative {
  color: #b71c1c;
}

@media (max-width: 991.98px) {
  .request-header-metrics {
    max-width: none;
  }
  .metric-item {
    grid-template-columns: 120px minmax(0, 1fr);
  }
}
@media (max-width: 575.98px) {
  .metric-item {
    grid-template-columns: 1fr;
    row-gap: 4px;
  }
}
.attachments-table-container {
  overflow-x: auto;
}

.test-iteration-selector {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  padding: 12px 16px;
  border-bottom: 1px solid #e0e0e0;
}

.test-iteration-btn {
  padding: 4px 14px;
  font-size: 0.85rem;
  border: 1px solid #bdbdbd;
  border-radius: 16px;
  background: #fff;
  cursor: pointer;
  color: #424242;
  white-space: nowrap;
  transition: background 0.15s, border-color 0.15s, color 0.15s;
}
.test-iteration-btn:hover {
  background: #f5f5f5;
  border-color: #9e9e9e;
}
.test-iteration-btn.active {
  background: #1976d2;
  border-color: #1976d2;
  color: #fff;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/job-details/job-request-details/job-request-details.component.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,gBAAA;AACF;;AAEA;EACE,gBAAA;EACA,aAAA;EACA,QAAA;EACA,gBAAA;EACA,yBAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;AACF;;AAEA;EACE,aAAA;EACA,2CAAA;EACA,mBAAA;EACA,gBAAA;AACF;;AAEA;EACE,eAAA;EACA,kDAAA;EACA,WAAA;EACA,SAAA;AACF;;AAEA;EACE,eAAA;EACA,gBAAA;EACA,WAAA;EACA,yBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;AACF;;AAEA;EACE,mBAAA;AACF;;AAEA;EACE,gBAAA;EACA,WAAA;AACF;AACE;EACE,cAAA;AACJ;AAEE;EACE,cAAA;AAAJ;;AAIA;EACE;IACE,eAAA;EADF;EAIA;IACE,2CAAA;EAFF;AACF;AAKA;EACE;IACE,0BAAA;IACA,YAAA;EAHF;AACF;AAMA;EACE,gBAAA;AAJF;;AAOA;EACE,aAAA;EACA,eAAA;EACA,QAAA;EACA,kBAAA;EACA,gCAAA;AAJF;;AAOA;EACE,iBAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,mBAAA;EACA,6DAAA;AAJF;AAME;EACE,mBAAA;EACA,qBAAA;AAJJ;AAOE;EACE,mBAAA;EACA,qBAAA;EACA,WAAA;AALJ","sourcesContent":[".material {\n  color: #666;\n  font-weight: 400;\n}\n\n.request-header-metrics {\n  margin-top: 10px;\n  display: grid;\n  gap: 8px;\n  max-width: 640px;\n  background-color: #f7f8fa;\n  border: 1px solid #e9ecef;\n  border-radius: 6px;\n  padding: 10px 12px;\n}\n\n.metric-item {\n  display: grid;\n  grid-template-columns: 130px minmax(0, 1fr);\n  align-items: center;\n  column-gap: 10px;\n}\n\n.metric-label {\n  font-size: 1rem;\n  font-family: \"GothamNarrowBold\", Arial, sans-serif;\n  color: #111;\n  margin: 0;\n}\n\n.metric-value {\n  font-size: 1rem;\n  line-height: 1.3;\n  color: #555;\n  background-color: #ededee;\n  border-radius: 4px;\n  padding: 4px 10px;\n  min-height: 30px;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  flex-wrap: wrap;\n}\n\n.metric-unit {\n  white-space: nowrap;\n}\n\n.metric-delta {\n  font-weight: 600;\n  color: #555;\n\n  &.positive {\n    color: #1b5e20;\n  }\n\n  &.negative {\n    color: #b71c1c;\n  }\n}\n\n@media (max-width: 991.98px) {\n  .request-header-metrics {\n    max-width: none;\n  }\n\n  .metric-item {\n    grid-template-columns: 120px minmax(0, 1fr);\n  }\n}\n\n@media (max-width: 575.98px) {\n  .metric-item {\n    grid-template-columns: 1fr;\n    row-gap: 4px;\n  }\n}\n\n.attachments-table-container {\n  overflow-x: auto;\n}\n\n.test-iteration-selector {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n  padding: 12px 16px;\n  border-bottom: 1px solid #e0e0e0;\n}\n\n.test-iteration-btn {\n  padding: 4px 14px;\n  font-size: 0.85rem;\n  border: 1px solid #bdbdbd;\n  border-radius: 16px;\n  background: #fff;\n  cursor: pointer;\n  color: #424242;\n  white-space: nowrap;\n  transition: background 0.15s, border-color 0.15s, color 0.15s;\n\n  &:hover {\n    background: #f5f5f5;\n    border-color: #9e9e9e;\n  }\n\n  &.active {\n    background: #1976d2;\n    border-color: #1976d2;\n    color: #fff;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
